let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("jAS45")).then(() => parcelRequire('97Kac'));